export const LINK = 'link';
